import $ from 'jquery';

function generateList($el, tag, cb) {
  var listFrag = $('<div />');

  $el.each(function (i, el) {
    listFrag.append(cb(el, i, tag));
  });

  return listFrag.html();
}

function Slider(opt) {
  this.$el = $(opt.container);

  if (this.$el.length < 1) {
    return;
  }

  this.$listContainer = this.$el.find(opt.listContainer);
  this.$pageContainer = this.$el.find(opt.pageContainer);
  this.$slides = this.$el.find(opt.slides);
  this.$images = this.$el.find(opt.images);

  this.listActiveClass = opt.listActiveClass;
  this.listPerPage = opt.listPerPage;
  this.listPageWidth = opt.listPageWidth;
  this.listWidth = opt.listWidth;

  this.blankList = this.$el.find(opt.blankList).clone();
  this.isMoveByPage = opt.isMoveByPage;

  this.total = this.$slides.length;
  this.index = 0;
  this.startIndex =
    opt.startIndex === 'random' ? Math.floor(Math.random() * this.total) : opt.startIndex || 0;

  this.nowPage = 1;
  this.totalListPages = Math.ceil(this.total / this.listPerPage);
  this.listOffset = 0;
  this.listOffsetLeft = 0;
  this.pagination = opt.pagination ? opt.pagination : false;

  this.$prevSlide = this.$el.find(opt.prevSlide);
  this.$nextSlide = this.$el.find(opt.nextSlide);

  this.listTags = generateList(this.$images, opt.listTag, function (el, i, tag) {
    var titleText = $(el).attr('alt');

    return $(tag.replace(/{altText}/, titleText).replace(/{slideId}/, i));
  });

  if (this.pagination) {
    this.pageTags = generateList(this.$images, opt.pageTag, function (el, i, tag) {
      var titleText = $(el).attr('alt');
      return $(tag.replace(/{altText}/, titleText).replace(/{slideId}/, i));
    });
  }
}

Slider.prototype.bindClickList = function () {
  this.$listContainer.click($.proxy(handler, this));
  if (this.pagination) {
    this.$pageContainer.click($.proxy(handler, this));
  }

  function handler(e) {
    e.preventDefault();
    var $ev = $(e.target);
    if ($ev.is('[data-target]')) {
      this.$el.trigger('show/slide', { target: $ev.data('target') });
    }
  }
};

Slider.prototype.bindShowSlide = function () {
  this.$el.bind(
    'show/slide',
    $.proxy(function (e, data) {
      var targetNum = parseInt(data.target, 10);

      this.index = targetNum;

      this.listOffset = this.index % this.listPerPage;

      this.$slides.hide().eq(targetNum).show();

      this.$listContainer.find('[data-target]').each(
        $.proxy(function (i, el) {
          if (i === targetNum) {
            $(el).addClass(this.listActiveClass);
          } else {
            $(el).removeClass(this.listActiveClass);
          }
        }, this)
      );
    }, this)
  );
};

Slider.prototype.bindPrevNext = function () {
  // 이전 클릭
  this.$prevSlide.click(
    $.proxy(function (e) {
      e.preventDefault();

      var toIndex = this.index - 1;

      if (toIndex < 0) {
        toIndex = this.total - 1;
      }

      this.$el.trigger('show/slide', { target: toIndex });
      this.$el.trigger('prev/slide');
    }, this)
  );

  // 다음 클릭
  this.$nextSlide.click(
    $.proxy(function (e) {
      e.preventDefault();

      var toIndex = this.index + 1;

      if (toIndex >= this.total) {
        toIndex = 0;
      }

      this.$el.trigger('show/slide', { target: toIndex });
      this.$el.trigger('next/slide');
    }, this)
  );
};

Slider.prototype.moveListPage = function () {
  this.$el.bind(
    'show/slide',
    $.proxy(function (e, data) {
      // 페이지 단위 이동
      var index = parseInt(data.target, 10);
      var toPage = Math.ceil((index + 1) / this.listPerPage);
      this.$listContainer.animate(
        {
          left: this.listPageWidth * (toPage - 1) * -1
        },
        150,
        $.proxy(function () {
          this.nowPage = toPage;
        }, this)
      );
    }, this)
  );
};

Slider.prototype.moveListOne = function () {
  this.$el.bind(
    'prev/slide',
    $.proxy(function () {}, this)
  );

  this.$el.bind(
    'next/slide',
    $.proxy(function () {}, this)
  );
};

Slider.prototype.fillBlankList = function () {
  var toFill = this.totalListPages * this.listPerPage - this.total;

  for (var i = 0; i < toFill; i += 1) {
    this.blankList.clone().appendTo(this.$listContainer);
  }
};

Slider.prototype.generatePagination = function () {
  this.$pageContainer.html(this.pageTags);
  this.$el.bind(
    'show/slide',
    $.proxy(function (e, data) {
      var targetNum = parseInt(data.target, 10);
      this.$pageContainer.find('[data-target]').each(
        $.proxy(function (i, el) {
          if (i === targetNum) {
            $(el).addClass(this.listActiveClass);
          } else {
            $(el).removeClass(this.listActiveClass);
          }
        }, this)
      );
    }, this)
  );
};

Slider.prototype.start = function (cb) {
  this.$listContainer.hide();
  this.$listContainer.html(this.listTags);
  this.fillBlankList();

  this.bindClickList();
  this.bindShowSlide();
  this.bindPrevNext();

  if (this.pagination) {
    this.generatePagination();
  }

  if (this.isMoveByPage) {
    this.moveListPage();
  } else {
    this.moveListOne();
  }

  this.$el.trigger('show/slide', { target: this.startIndex, speed: 0 });

  this.$listContainer.show();

  if ($.isFunction(cb)) {
    cb.call(this.$el);
  }
};

export default Slider;
